/**
 * API Configuration
 * Separate configurations for Django and Spring backends
 */

const ENV = process.env.REACT_APP_ENV || "development";

// Export configuration
export const API_CONFIG = {
  ENV,
  // Django Backend URL
  DJANGO_BASE_URL: process.env.REACT_APP_SF_DJANGO_BASE_API_URL,
  // Spring Backend URL (Primary)
  SPRING_BASE_URL:
    process.env.REACT_APP_SF_SPRING_BASE_API_URL ||
    process.env.REACT_APP_SF_BASE_API_URL,
};

// Get Django base URL
export const getDjangoBaseURL = () => API_CONFIG.DJANGO_BASE_URL;

// Get Spring base URL
export const getSpringBaseURL = () => API_CONFIG.SPRING_BASE_URL;

export default API_CONFIG;
